/**
 * Reset / refresh icon.
 *
 * @return {*} jsx
 */
export default function ResetIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
			<path fill="currentColor" d="M22 12a9.7 9.7 0 0 1-2.862 6.862A9.7 9.7 0 0 1 13 21v-2a7 7 0 0 0 4.962-2.038A7 7 0 0 0 20 12a7 7 0 0 0-2.038-4.962A7 7 0 0 0 13 5a7 7 0 0 0-4.962 2.038A7 7 0 0 0 6 12v.15l1.55-1.55L9 12l-4 4-4-4 1.45-1.4L4 12.15V12a9.7 9.7 0 0 1 2.862-6.862A9.7 9.7 0 0 1 13 3a9.7 9.7 0 0 1 6.862 2.862A9.7 9.7 0 0 1 22 12" />
		</svg>
	);
}
